import React, { Component } from "react"
import { connect } from "react-redux";

import { ForgotPasswordService } from "../../services/common/action";
import { ToastContainer, } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { NavLink } from "react-router-dom";
import Loader from "react-loader-spinner";


 
class ForgotPassword extends Component {
    constructor(props) {
 
        super(props)
        this.state = {
            username: "",
            loginDetails: ""
        };
    }


    handleChange = (e) => {
        e.preventDefault();
        this.setState({ username: e.target.value });
    };

 

    handleLogin = (e) => {
        e.preventDefault();
 
        var payLoad = {
            "username":this.state.username,
         };
        this.props.ForgotPasswordService(payLoad);
   }
   



  componentWillReceiveProps = nextProps => {

    if (nextProps.forgotPasswordStatus) {
          this.props.history.push("/CreateNewPassword")
    }  
  };


    render() {
        const { isLoading } = this.props;

        return (
            <>
             {isLoading && (
                    <div className="pop-mod">
                        <div className="loder-back">
                            <Loader
                                type="Ball-Triangle"
                                color="#CC6900"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                )}

                  <ToastContainer hideProgressBar autoClose={3000} /> 
               
                 <div className="login-wrapper2">
                 <div className="login-sec">
                <div className="login-box">
                    <form onSubmit={this.handleLogin}>
                    <h1>Forgot Password</h1>
                  <div className="row input-section" >
                      <div className="form-group pos-relative">
                    
                                <input type="text" onChange={this.handleChange}
                                            name="username" value={this.state.username} placeholder="Email / Mobile" />
                          <div className="input-icon">
                              <img alt="" src="images/loginmai1l.png"/>
                          </div>
                      </div>
                      
                    
                    <div className="form-group">
                        <div className="login-btn">
                            <button type="submit">Submit</button>
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <div className="agree-site-rule">
                            
                            <NavLink to="/login" >
                                            Back To Login
                            </NavLink>
                        </div>
                     </div>
                  </div>
                  </form>
                </div>
                <div className="footer-login">
                        <ul>
                        <li> <a href="https://ferndaleroad.com/about-us/"> About us</a></li>
                                    <li><NavLink to="/Contact" > Contact and Support</NavLink></li>
                                  
                                    <li><NavLink to="/PrivacyPage">Privacy Policy</NavLink></li>
                        </ul>
                    </div> 
           
                
            </div>

                     

                </div>
               
            </>
        )
    }
}
const mapStateToProps = state => ({
    forgotPasswordStatus: state.commonReducer.forgotPasswordStatus,
    message: state.commonReducer.message,
    loginDetails: state.commonReducer.loginDetails,
    isLoading: state.commonReducer.isLoading



});

const mapDispatchToProps = dispatch => ({
    ForgotPasswordService: payLoad => dispatch(ForgotPasswordService(payLoad))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword);
 